import makeStyles from 'e100-react-components/lib/styles/makeStyles';

import { TextColor } from '../../../hooks/useTextColor';

interface Props {
  textColor: TextColor;
}

const useStyles = makeStyles(({ spacing }) => ({
  iconRoot: ({ textColor }: Props) => ({
    padding: spacing(1),
  }),
}));

export default useStyles;
